import { render } from "./IconItemCategoryDonation.vue?vue&type=template&id=19659a44"
import script from "./IconItemCategoryDonation.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryDonation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__